import { Form as FinalForm, Field } from 'react-final-form'
import { observer } from 'mobx-react-lite'
import { makeStyles } from '@mui/styles'
import { styled, Theme } from '@mui/material/styles'
import { Grid, Dialog, Paper, Stack, Typography, Divider, Button } from '@mui/material'
import CoreHeader from './CoreHeader'
import CoreFooter from './CoreFooter'
import Textbox from '../../control/Textbox'
import Scrollbar from '../../control/Scrollbar'
import useFormFeedback from '../../hooks/map/useFormFeedback'
import NumberTextbox from '../../control/NumberTextbox'
import DropdownInput from '../input/DropdownInput'
import withDialog, { CallBackOpenDialog } from '../../control/dialogAlert/withDialog'
import { getDecimalBySpecificDigit } from '../../util/utilityFunction'
import DialogControl from '../../control/Dialog'
import useMapStore from '../../stores/useMapStore'

type FormFeedbackProps = CallBackOpenDialog
let FormFeedback = (props: FormFeedbackProps) => {
    const classes = useStyles()
    const { t, openDialog, setOpenDialog, formProps, lookups, data, dialogAlert } = useFormFeedback(props)
    const mapStore = useMapStore()

    return (
        <>
            <Dialog
                fullScreen
                open={openDialog}
                onClose={() => {
                    setOpenDialog(false)
                }}
            >
                <CoreHeader />

                <StyledContent>
                    <div style={{ width: '100%', height: '100%' }}>
                        <Scrollbar scrollbarTrackBorderRadius={10} scrollbarThumbBorderRadius={10}>
                            <StyledContainer>
                                <Paper elevation={3} sx={{ px: 4, py: 2 }}>
                                    <Stack spacing={1}>
                                        <StyledTypoTitleSubject>ข้อมูลสถานีส่งสัญญาณ</StyledTypoTitleSubject>
                                        <Divider />

                                        <Grid container spacing={1.5}>
                                            <Grid item xs={12} md={6} display={'flex'}>
                                                <Typography>
                                                    <span>
                                                        <b>ชื่อสถานี : </b>
                                                        {data?.name_th}
                                                    </span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={6} display={'flex'}>
                                                <Typography>
                                                    <span>
                                                        <b>มุมเทียบกับทิศเหนือ : </b>
                                                        {(data?.azimuth && data?.azimuth.toFixed(0) + '°') || '-'}
                                                    </span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={6} display={'flex'}>
                                                <Typography>
                                                    <span>
                                                        <b>ค่ากำลังส่งออกอากาศ (ERP) : </b>
                                                        {`${data?.erp} kW`}
                                                    </span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} md={6} display={'flex'}>
                                                <Typography>
                                                    <span>
                                                        <b>ความสูงสายอากาศ : </b>
                                                        {`${data?.height} m`}
                                                    </span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} display={'flex'}>
                                                <Typography>
                                                    <span>
                                                        <b>ที่อยู่ : </b>
                                                        {data?.address}
                                                    </span>
                                                </Typography>
                                            </Grid>
                                            <Grid item xs={12} display={'flex'}>
                                                <Typography>
                                                    <span>
                                                        <b>พิกัดส่งข้อเสนอแนะ : </b>
                                                        {`${getDecimalBySpecificDigit(
                                                            mapStore.selectedLocation?.latitude,
                                                        )}, ${getDecimalBySpecificDigit(
                                                            mapStore.selectedLocation?.longitude,
                                                        )}`}
                                                    </span>
                                                </Typography>
                                            </Grid>
                                        </Grid>
                                        <Divider />

                                        <StyledTypoTitleHead>{t('MENU.FEEDBACK')}</StyledTypoTitleHead>

                                        <FinalForm
                                            onSubmit={formProps.onSubmitForm}
                                            validate={formProps.validates}
                                            initialValues={formProps.initialValues}
                                        >
                                            {(forms) => {
                                                return (
                                                    <form onSubmit={forms.handleSubmit}>
                                                        <Grid container spacing={1.5}>
                                                            <Grid item xs={12} md={6}>
                                                                <Field
                                                                    name="stable"
                                                                    label={t('LABEL.STATBLE')}
                                                                    placeholder={t('LABEL.IDENTIFY_RECEPTION')}
                                                                    component={DropdownInput}
                                                                    options={lookups.stable.map((item) => {
                                                                        return {
                                                                            value: item.code,
                                                                            label: item.name,
                                                                        }
                                                                    })}
                                                                    fullWidth
                                                                    onChange={(event: any) => {
                                                                        forms.form.change('stable', event as number)
                                                                        const num = event as number
                                                                        if (num !== 2) {
                                                                            forms.form.change('abnormal')
                                                                        }
                                                                    }}
                                                                    required
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Field
                                                                    name="abnormal"
                                                                    label={t('LABEL.ABNORMAL')}
                                                                    component={Textbox}
                                                                    fullWidth
                                                                    disabled={!(forms.values.stable === 2)}
                                                                    required={forms.values.stable === 2}
                                                                    maxLength={254}
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Field
                                                                    name="antennaType"
                                                                    label={t('LABEL.SIGNAL_ANTENNA')}
                                                                    placeholder={t('LABEL.IDENTIFY_RECEPTION')}
                                                                    component={DropdownInput}
                                                                    options={lookups.antennaType.map((item) => {
                                                                        return {
                                                                            value: item.code,
                                                                            label: item.name,
                                                                        }
                                                                    })}
                                                                    optionProps={['code', 'name']}
                                                                    fullWidth
                                                                    required
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Field
                                                                    name="antennaHeight"
                                                                    label={t('LABEL.ANTENNA_HEIGHT')}
                                                                    component={NumberTextbox}
                                                                    min={0}
                                                                    fullWidth
                                                                    disabled={forms.values.antennaType === 0}
                                                                    required={!(forms.values.antennaType === 0)}
                                                                    inputType="number"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Field
                                                                    name="distanceDoor"
                                                                    label={t('LABEL.DISTANCE_DOOR')}
                                                                    component={NumberTextbox}
                                                                    min={0}
                                                                    fullWidth
                                                                    disabled={
                                                                        forms.values.antennaType === 0 ||
                                                                        forms.values.antennaType === 1
                                                                    }
                                                                    required={
                                                                        forms.values.antennaType !== 0 &&
                                                                        forms.values.antennaType !== 1
                                                                    }
                                                                    inputType="number"
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12} md={6}>
                                                                <Field
                                                                    name="directionDoor"
                                                                    label={t('LABEL.DIRECTION_DOOR')}
                                                                    component={DropdownInput}
                                                                    options={lookups.door.map((item) => {
                                                                        return {
                                                                            value: item.code,
                                                                            label: item.name,
                                                                        }
                                                                    })}
                                                                    fullWidth
                                                                    disabled={
                                                                        forms.values.antennaType === 0 ||
                                                                        forms.values.antennaType === 1
                                                                    }
                                                                />
                                                            </Grid>
                                                            <Grid item xs={12}>
                                                                <Field
                                                                    name="comments"
                                                                    label={t('LABEL.COMMENT')}
                                                                    component={Textbox}
                                                                    fullWidth
                                                                    maxLength={254}
                                                                />
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                <Stack
                                                                    direction="row"
                                                                    spacing={2}
                                                                    justifyContent="flex-end"
                                                                >
                                                                    <Button
                                                                        variant="outlined"
                                                                        onClick={() => formProps.onClickCancel()}
                                                                        classes={{ root: classes.button }}
                                                                    >
                                                                        {t('BUTTON.CANCEL')}
                                                                    </Button>
                                                                    <Button
                                                                        variant="contained"
                                                                        color="primary"
                                                                        type="submit"
                                                                        classes={{ root: classes.button }}
                                                                    >
                                                                        {t('BUTTON.SEND_FEEDBACK')}
                                                                    </Button>
                                                                </Stack>
                                                            </Grid>
                                                        </Grid>
                                                    </form>
                                                )
                                            }}
                                        </FinalForm>
                                    </Stack>
                                </Paper>
                            </StyledContainer>
                        </Scrollbar>
                    </div>
                </StyledContent>
                <StyledFooter>
                    <CoreFooter />
                </StyledFooter>
            </Dialog>

            <DialogControl
                type="confirm"
                title={t('ALERT.TITLE.NOTIFY')}
                content={t('ALERT.CONTENT.DISCARD_CHANGE')}
                isOpen={dialogAlert.openDialogBack ? true : false}
                onClickCancel={dialogAlert.onClickConfirmBack}
                onClickConfirm={dialogAlert.onClickCancelBack}
                labelButtonCancel={t('BUTTON.LEAVE')}
                labelButtonConfirm={t('BUTTON.STAY')}
                disableClickBackdrop
                hideCloseButton
            />

            <DialogControl
                type="confirm"
                title={t('ALERT.TITLE.NOTIFY')}
                content={'ยืนยันบันทึกข้อมูล'}
                isOpen={dialogAlert.openDialogSave}
                onClickConfirm={dialogAlert.onClickConfirmSave}
                onClickCancel={dialogAlert.onClickCancelSave}
                labelButtonCancel={t('BUTTON.CANCEL')}
                labelButtonConfirm={t('BUTTON.CONFIRM')}
                disableClickBackdrop
                hideCloseButton
            />
        </>
    )
}

const useStyles = makeStyles((theme: Theme) => ({
    titleBody: {
        fontSize: '18px !important',
        fontWeight: 400,
        color: '#000 !important',
    },
    button: {
        width: '125px',
        minHeight: '37px',
        fontSize: '14px !important',
    },
}))

const StyledContent = styled('div')(({ theme }) => ({
    height: `calc(100% - 92px)`,
}))

const StyledContainer = styled('div')(({ theme }) => ({
    padding: '30px 100px',
    [theme.breakpoints.down('sm')]: {
        padding: '30px 20px',
    },
}))

const StyledFooter = styled('div')(({ theme }) => ({
    position: 'fixed',
    bottom: 0,
    width: '100%',
}))

const StyledTypoTitleSubject = styled(Typography)(({ theme }) => ({
    fontSize: '18px',
    fontWeight: 'bold',
    color: theme.palette.secondary.dark,
}))

const StyledTypoTitleHead = styled(Typography)(({ theme }) => ({
    marginTop: '15px !important',
    fontWeight: 'bold',
    color: theme.palette.primary.dark,
}))

FormFeedback = observer(FormFeedback)
FormFeedback = withDialog(FormFeedback)
export default FormFeedback
